import { useScrollOver } from '@gluedigital/scrollastic'
import { RefObject, useEffect, useState } from 'react'
import FeatureCard from './FeatureCard/FeatureCard'

import './Features.css'

interface FeaturesProps {
  scrollable?: RefObject<HTMLDivElement | null>
}

export default function Features({ scrollable }: FeaturesProps) {
  const scrollOver = useScrollOver(
    '#features',
    scrollable as RefObject<HTMLElement>
  )
  const [visibleFacts, setVisibleFacts] = useState([false, false, false])

  useEffect(() => {
    const newVisibleFacts = [
      scrollOver >= 0.19,
      scrollOver >= 0.43,
      scrollOver >= 0.66
    ]
    setVisibleFacts(newVisibleFacts)
  }, [scrollOver])

  return (
    <section id="features" className="landing-section">
      {[1, 2, 3].map((n, i) => (
        <FeatureCard key={n} dataId={n} revealed={visibleFacts[i]} />
      ))}
    </section>
  )
}
